import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import InterlacedLogoV2 from '@/components/ui/InterlacedLogoV2';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-svh flex items-end md:items-center justify-center md:justify-start px-4 pb-24 md:pb-0 pt-[calc(64px+env(safe-area-inset-top))]">
      {/* Background Image */}
      <picture className="absolute inset-0">
        <source media="(max-width: 768px)" srcSet="/images/hero-background-mobile.jpg" />
        <img
          src="/images/hero-background.jpg"
          alt="Casal elegante representando conexões exclusivas"
          className="w-full h-full object-cover"
          loading="eager"
          {...{ fetchpriority: 'high' }}
        />
      </picture>
      
      {/* Overlay Escuro */}
      <div className="absolute inset-0 bg-black/40" />
      
      {/* Fade para baixo */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-black" />

      {/* Content - Centralizado Mobile, Esquerda Desktop */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 text-center md:text-left max-w-2xl mx-auto md:mx-0 md:ml-12 lg:ml-24 xl:ml-32 px-4 md:px-0"
      >
        {/* Logo Vertical - Centralizado Mobile, Esquerda Desktop */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mb-8 md:mb-12 flex justify-center md:justify-start"
        >
          <InterlacedLogoV2 variant="vertical" size="lg" priority />
        </motion.div>

        {/* Headline - 3 Linhas */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-6"
        >
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold font-poppins leading-tight">
            <span className="block text-white md:whitespace-nowrap">Conexões com classe.</span>
            <span className="block text-[#E91E63] md:whitespace-nowrap">Acordos com desejo.</span>
            <span className="block text-white md:whitespace-nowrap">Experiências com propósito.</span>
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-base md:text-lg text-white/80 mb-8 md:mb-12 font-poppins max-w-xl"
        >
          Este não é mais um aplicativo. É um acesso restrito ao que poucos podem viver.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center md:justify-start"
        >
          <Button
            size="lg"
            variant="brand-gradient"
            onClick={() => navigate('/auth')}
            className="font-poppins text-lg px-10 py-7 rounded-full transition-all duration-300"
          >
            Começar agora &nbsp;&nbsp;&gt;&gt;
          </Button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
